/* BTP Cart Count — badge updates + change animation for header cart icons */
(function () {
  'use strict';

  var SELECTOR = '[data-btp-cart-count]';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getBadges() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function animateBadge(el) {
    if (!el || reducedMotion.matches) return;

    el.classList.remove('is-animating');
    void el.offsetWidth;
    el.classList.add('is-animating');

    function onEnd() {
      el.classList.remove('is-animating');
      el.removeEventListener('animationend', onEnd);
    }

    el.addEventListener('animationend', onEnd);
  }

  function renderBadge(el, count, animate) {
    var prev = parseInt(el.textContent, 10) || 0;
    var changed = prev !== count;
    var display = count > 99 ? '99+' : String(count);

    el.textContent = display;
    el.classList.toggle('is-visible', count > 0);

    if (animate && changed) {
      animateBadge(el);
    }
  }

  function updateCartCount(animate) {
    var badges = getBadges();
    if (!badges.length) return;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;

        badges.forEach(function (badge) {
          renderBadge(badge, count, animate);
        });
      })
      .catch(function () {});
  }

  updateCartCount(false);

  document.addEventListener('cart:update', function () {
    updateCartCount(true);
  });
  document.addEventListener('cart:updated', function () {
    updateCartCount(true);
  });
  document.addEventListener('cart:item-added', function () {
    updateCartCount(true);
  });
  document.addEventListener('cart:refresh', function () {
    updateCartCount(true);
  });
}());
